import { useEffect, useState } from 'react';

import { useStores } from '~store';

// Long enough that a blip ActionCable recovers from on its own never flashes the banner.
export const MESSAGING_RECONNECTING_GRACE_PERIOD_IN_MS = 5000;

export default function useIsMessagingReconnecting() {
  const { connection } = useStores().messagingConnectionStore;
  const [graceElapsedFor, setGraceElapsedFor] = useState<typeof connection | null>(null);

  useEffect(() => {
    if (connection.status !== 'disconnected') return;

    const remainingGraceInMs =
      connection.disconnectedAt + MESSAGING_RECONNECTING_GRACE_PERIOD_IN_MS - Date.now();
    const timer = setTimeout(
      () => setGraceElapsedFor(connection),
      Math.max(0, remainingGraceInMs),
    );

    return () => clearTimeout(timer);
  }, [connection]);

  return connection.status === 'disconnected' && graceElapsedFor === connection;
}
